namespace Solovis.UI.InputControls {

    export interface ValidationModelControlOptions extends Solovis.UI.BaseControlOptions {
        validationModel: Solovis.UI.InputControls.ValidationModel;
    }

    /**
     * ValidationModelControl will keep it's contents in sync with the provided validation state.
     */
    export class ValidationModelControl extends Solovis.UI.BaseControl {    
             
        public _validationModel: Solovis.UI.InputControls.ValidationModel;
        public _stateChangedCallback: () => void;

        constructor(options: ValidationModelControlOptions) {
            super(options);

            this._validationModel = options.validationModel;
            if (!this._validationModel) {
                throw "options.validationModel is required";
            }

            var self = this;
            this._stateChangedCallback = function () {
                if (self.state >= Solovis.UI.BaseControl.ControlState.afterRender &&
                    self.state < Solovis.UI.BaseControl.ControlState.beforeDestroy) {
                    self.doRender();
                }
            };

            $(this._validationModel).bind("stateChanged", this._stateChangedCallback);
        }


        public doDestroy() {
            $(this._validationModel).unbind("stateChanged", this._stateChangedCallback);
        }

        public doRender() {
            this.container.html("");

            var getDisplayElement = function (messageHolder) {
                var div = $("<div>")
                    .addClass("input-validation");

                if (messageHolder.html) {
                    div.html(messageHolder.html);
                }
                else if (messageHolder.message) {
                    div.text(messageHolder.message);
                }
                return div;
            }

            var state = this._validationModel.state();
            if (state) {
                var displayDiv;
                if (state.error) {
                    displayDiv = getDisplayElement(state.error);
                    displayDiv.addClass("input-validation-error");
                }
                else if (state.success) {
                    displayDiv = getDisplayElement(state.success);
                    displayDiv.addClass("input-validation-success");
                }

                displayDiv.appendTo(this.container);
            }
        }
    }

}
